import React from 'react';
import Loading from '../../../components/Loading';

const LoadingScreen: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgb(255, 255, 255)',
            zIndex: 1000,
            height: '100vh',
            width: '100vw',
          }}
        >
          <Loading loading={isLoading} color="var(--primary)" width={30} />
        </div>
      )}
    </>
  );
};

export default LoadingScreen;
